/* KieroKombucha — página de producto (Sesión 2). JS mínimo, sin frameworks:
   1) swap de galería (miniatura -> imagen principal)
   2) selección de variante (cuando el producto tiene más de una opción)
   3) selección de plan de venta / suscripción (cuando el producto lo tiene) —
      el precio mostrado se recalcula según variante + plan elegidos. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // --- Galería ---
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (main) {
            main.src = thumb.getAttribute('data-full');
            main.srcset = '';
          }
        });
      });
    });

    // --- Stepper de cantidad (independiente del carrito, solo para el form de agregar) ---
    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      var dec = stepper.querySelector('[data-qty-decrease]');
      var inc = stepper.querySelector('[data-qty-increase]');
      if (!input) return;
      if (dec) dec.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (inc) inc.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    // --- Selector de variantes + plan de venta ---
    document.querySelectorAll('[data-product-form]').forEach(function (formEl) {
      var dataEl = formEl.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

      // El precio, el precio tachado y el badge de disponibilidad viven FUERA
      // del <form> en el markup (arriba, en .buy-box), así que hay que
      // buscarlos en un contenedor más amplio — buscarlos con formEl.querySelector
      // siempre devuelve null y esos elementos nunca se actualizan (bug real
      // detectado 27 jul: el precio no cambiaba al elegir plan de suscripción).
      var scopeEl = formEl.closest('.buy-box') || document;
      var optionSelects = formEl.querySelectorAll('[data-option-select]');
      var variantIdInput = formEl.querySelector('[data-variant-id]');
      var priceNow = scopeEl.querySelector('[data-price-now]');
      var priceCompare = scopeEl.querySelector('[data-price-compare]');
      var availEl = scopeEl.querySelector('[data-availability]');
      var addBtn = formEl.querySelector('[data-add-button]');
      var sellingPlanRadios = formEl.querySelectorAll('[data-selling-plan-radio]');
      var sellingPlanInput = formEl.querySelector('[data-selling-plan-input]');

      function moneyFormat(cents) {
        return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      function findVariant() {
        var selected = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function selectedSellingPlanId() {
        var checked = Array.prototype.find.call(sellingPlanRadios, function (r) { return r.checked; });
        return checked ? checked.value : '';
      }

      function updateUI() {
        var variant = findVariant();
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;

        var price = variant.price;
        var comparePrice = variant.compare_at_price;
        var planId = selectedSellingPlanId();
        if (planId && variant.selling_plans && variant.selling_plans[planId]) {
          price = variant.selling_plans[planId].price;
          comparePrice = variant.selling_plans[planId].compare_at_price;
        }

        if (priceNow) priceNow.textContent = moneyFormat(price);
        if (priceCompare) {
          if (comparePrice && comparePrice > price) {
            priceCompare.textContent = moneyFormat(comparePrice);
            priceCompare.style.display = '';
          } else {
            priceCompare.style.display = 'none';
          }
        }
        if (availEl) {
          if (variant.available) {
            availEl.textContent = 'En stock';
            availEl.classList.remove('out');
            availEl.classList.add('in-stock');
          } else {
            availEl.textContent = 'Agotado';
            availEl.classList.remove('in-stock');
            availEl.classList.add('out');
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
        }
      }

      optionSelects.forEach(function (select) {
        select.addEventListener('change', updateUI);
      });

      // --- Selector de plan de venta / suscripción ---
      if (sellingPlanInput && sellingPlanRadios.length) {
        sellingPlanRadios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            if (radio.value === '') {
              sellingPlanInput.disabled = true;
              sellingPlanInput.value = '';
            } else {
              sellingPlanInput.disabled = false;
              sellingPlanInput.value = radio.value;
            }
            updateUI();
          });
        });
      }
    });
  });
})();
